var _path, _g, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPractice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1549_45127",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0232 0.333984H0.833984V28.334H22.0232V23.0365L19.7525 25.3072V16.2261L22.0232 13.9554V0.333984Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1549_45127)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9688 4.117L21.266 9.4143H15.9688V4.117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9682 4.87364C15.9682 4.45569 15.6294 4.11688 15.2114 4.11688H4.61711C4.19916 4.11688 3.86035 4.45569 3.86035 4.87364V25.3061C3.86035 25.724 4.19916 26.0628 4.61711 26.0628H20.509C20.9269 26.0628 21.2658 25.724 21.2658 25.3061V10.1709C21.2658 9.75299 20.9269 9.41418 20.509 9.41418H16.7249C16.307 9.41418 15.9682 9.07537 15.9682 8.65742V4.87364Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.61711 4.64661H15.2114V3.58715H4.61711V4.64661ZM4.39008 25.3061V4.87364H3.33062V25.3061H4.39008ZM20.509 25.5331H4.61711V26.5926H20.509V25.5331ZM20.736 10.1709V25.3061H21.7955V10.1709H20.736ZM20.509 8.88445H16.7249V9.94391H20.509V8.88445ZM16.4979 8.65742V4.87364H15.4384V8.65742H16.4979ZM16.7249 8.88445C16.5995 8.88445 16.4979 8.78281 16.4979 8.65742H15.4384C15.4384 9.36793 16.0144 9.94391 16.7249 9.94391V8.88445ZM21.7955 10.1709C21.7955 9.46043 21.2195 8.88445 20.509 8.88445V9.94391C20.6344 9.94391 20.736 10.0456 20.736 10.1709H21.7955ZM20.509 26.5926C21.2195 26.5926 21.7955 26.0166 21.7955 25.3061H20.736C20.736 25.4315 20.6344 25.5331 20.509 25.5331V26.5926ZM3.33062 25.3061C3.33062 26.0166 3.9066 26.5926 4.61711 26.5926V25.5331C4.49172 25.5331 4.39008 25.4315 4.39008 25.3061H3.33062ZM15.2114 4.64661C15.3368 4.64661 15.4384 4.74826 15.4384 4.87364H16.4979C16.4979 4.16313 15.9219 3.58715 15.2114 3.58715V4.64661ZM4.61711 3.58715C3.9066 3.58715 3.33062 4.16313 3.33062 4.87364H4.39008C4.39008 4.74826 4.49173 4.64661 4.61711 4.64661V3.58715Z",
    fill: "#EB0000",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5898 4.117L21.1394 9.66655",
    stroke: "#EB0000",
    strokeOpacity: 0.6,
    strokeWidth: 1.05946,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53711 13.1378L8.27259 14.8732L10.5866 12.5593",
    stroke: "#EB0000",
    strokeOpacity: 0.6,
    strokeWidth: 1.05946,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1846 11.686H18.617",
    stroke: "#EB0000",
    strokeOpacity: 0.6,
    strokeWidth: 1.05946,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1846 13.9563H17.8602",
    stroke: "#EB0000",
    strokeOpacity: 0.6,
    strokeWidth: 1.05946,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53711 19.6824L8.27259 21.4179L10.5866 19.1039",
    stroke: "#EB0000",
    strokeOpacity: 0.6,
    strokeWidth: 1.05946,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1846 17.7394H16.3467",
    stroke: "#EB0000",
    strokeOpacity: 0.6,
    strokeWidth: 1.05946,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1846 20.0096H14.8332",
    stroke: "#EB0000",
    strokeOpacity: 0.6,
    strokeWidth: 1.05946,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9785 23.5396H19.501L26.1227 16.918C26.4572 16.5835 26.6451 16.1298 26.6451 15.6567C26.6451 15.1837 26.4572 14.73 26.1227 14.3955C25.7882 14.061 25.3345 13.873 24.8614 13.873C24.3883 13.873 23.9346 14.061 23.6001 14.3955L16.9785 21.0171V23.5396Z",
    fill: "white",
    stroke: "#EB0000",
    strokeOpacity: 0.6,
    strokeWidth: 1.05946,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9697 15.0268L25.4922 17.5493",
    stroke: "#EB0000",
    strokeOpacity: 0.6,
    strokeWidth: 1.05946,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPractice);
export default __webpack_public_path__ + "static/media/icon_practice.b73ef3f4e5c31cb12c759e79fd095d50.svg";
export { ForwardRef as ReactComponent };